import React, { useMemo } from "react";
import { useWorkspaceAccounts } from "../../../api/account.api";
import styles from "./RuleEntityAction.module.scss";

interface Props {
    value: string;
}

export const RuleAccountAction: React.FC<Props> = ({ value }) => {
    const { data: accounts } = useWorkspaceAccounts();

    const account = useMemo(
        () =>
            accounts?.find((a) => {
                if (value) {
                    return a.id === value;
                }
                return false;
            }),
        [accounts, value],
    );

    if (!account) {
        return null;
    }

    return (
        <div>
            Assign to{" "}
            <div className={styles.entityLead}>
                <strong>{account.code}</strong> - {account?.name}
            </div>
        </div>
    );
};
